import { type IAdvancedRichText } from '@framework/engine/inputs/rich-text-advanced/IAdvancedRichText.ts';
import { type IInputWidget } from '@framework/engine/schema/widgets/repository/inputs/IInputWidget.ts';
import {
  type IBaseLayoutOptions,
  type WidgetType,
} from '@framework/engine/schema/widgets/Widget.ts';

export interface IEmailVerificationWidgetLayout extends IBaseLayoutOptions {
  /** Nascondi etichetta */
  // hideLabel?: boolean;
  startButtonText?: string;
  startHelpText?: IAdvancedRichText;
  endButtonText?: string;
  endHelpText?: IAdvancedRichText;
}

export const WidgetEmailVerificationType =
  'email-verification' as WidgetType.EmailVerification;

/**
 * Input in Verifica Email
 */
export interface IEmailVerificationWidget extends IInputWidget {
  type: WidgetType.EmailVerification;

  layout?: IEmailVerificationWidgetLayout;
}
